import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/mian.vue';
import home from '../views/system/home/index.vue';
import register from '../views/system/register/index.vue';
import login from "../views/system/login/index.vue"
import useLogin from "../views/system/useLogin/index.vue"
import bidderHome from '../views/bidder/bidderHome/index.vue';
import registration from '../views/bidder/registration/index.vue';
import registrationStatus from '../views/bidder/registrationStatus/index.vue';
import uploadBid from '../views/bidder/uploadBid/index.vue';
import inviteBidding from '../views/bidder/inviteBidding/index.vue';
import inviteBiddingPurchase from '../views/bidder/inviteBiddingPurchase/index.vue';
import myOrders from '../views/bidder/myOrders/index.vue';
import myPurchaseProjects from '../views/bidder/myPurchaseProjects/index.vue';
import supplementProcurement from '../views/bidder/supplementProcurement/index.vue';
import organizationModify from '../views/bidder/organizationModify/index.vue';
import professionalPersonnel from '../views/bidder/professionalPersonnel/index.vue';
import changePassword from '../views/bidder/changePassword/index.vue';
import userInfoModify from '../views/bidder/userInfoModify/index.vue';
import creditQuery from '../views/bidder/creditQuery/index.vue';
import caManagement from '../views/bidder/caManagement/index.vue';
import todoList from '../views/bidder/todoList/index.vue';
// 代理页面导入
import agentHome from '../views/agent/agentHome/index.vue';
// // 交易页面导入
import deal from '../views/system/deal/index.vue';
// 首页详情页面
import homeDetail from '../views/system/home/homeDetail.vue';
import downloadCenter from '../views/system/downloadCenter/index.vue';
// CA办理页面
import caHandle from '../views/system/ca/index.vue';
import caFileTest from '../views/system/caFileTest/index.vue';
import caLocalSignPathTest from '../views/system/caFileTest/localSignPathTest.vue';

import workbench from '../views/agent/workbench/index.vue';
import agentProject from '../views/agent/agentProject/index.vue';
import financeManagement from '../views/agent/financeManagement/index.vue';
import earnestMoneyCheck from '../views/agent/EarnestMoney/check.vue';
import earnestMoneyRefund from '../views/agent/EarnestMoney/refund.vue';





import announcementAudit from '../views/agent/announcementAudit/index.vue';
import candidateAudit from '../views/agent/candidateAudit/index.vue';
import resultAudit from '../views/agent/resultAudit/index.vue';
import noticeAudit from '../views/agent/noticeAudit/index.vue';
import auditStatusModify from '../views/agent/auditStatusModify/index.vue';
import bidderRegistrationAudit from '../views/agent/bidderRegistrationAudit/index.vue';
import caBinding from '../views/agent/caBinding/index.vue';
import agentorganizationModify from '../views/agent/organizationModify/index.vue';
import semiProcess from '../views/agent/semiProcess/index.vue';
// 企业采购页面导入
import openTendering from '../views/agent/openTendering/index.vue';
import competitiveNegotiation from '../views/agent/competitiveNegotiation/index.vue';
import competitiveConsultation from '../views/agent/competitiveConsultation/index.vue';
import invitationTendering from '../views/agent/invitationTendering/index.vue';
import inquiryProcurement from '../views/agent/inquiryProcurement/index.vue';
import singleSource from '../views/agent/singleSource/index.vue';
import addTender from '../views/agent/agentChild/addTender.vue';
import politicsProjectFlow from '../views/agent/agentChild/politicsProjectFlow.vue';
import valuationbefore from '../views/agent/agentChild/valuationbefore.vue';

import politicsProjectCreate from '../views/agent/agentChild/politicsProjectCreate.vue';
import politicsProjectManage from '../views/agent/agentChild/politicsProjectManage.vue';

import biddingPlan from '../views/agent/agentChild/biddingPlan.vue';
import biddingPlanAdd from '../views/agent/agentChild/biddingPlanAdd.vue';
import pioneerList from '../views/agent/agentChild/pioneerList.vue';



import tenderProMgmt from '../views/agent/agentChild/tenderProMgmt.vue';
import creatBidFile from '../views/agent/agentChild/creatBidFile.vue';
import uploadBidFile from '../views/agent/agentChild/uploadBidFile.vue';
import detailUploadFile from '../views/agent/agentChild/detailUploadFile.vue';
import qualificationReview from '../views/agent/agentChild/qualificationReview.vue';
import winningBidAnnouncement from '../views/agent/agentChild/winningBidAnnouncement.vue';
import addBidNotice from '../views/agent/agentChild/addBidNotice.vue';
import bidEvaluationMethod from '../views/agent/bidEvaluation/bidEvaluationMethod.vue';
import bidOpeningHall from '../views/agent/agentChild/bidOpeningHall.vue';
import judgeInfoEntry from '../views/agent/agentChild/judgeInfoEntry.vue';
import bidResultNotification from '../views/agent/agentChild/bidResultNotification.vue';
import publishTenderAnnouncement from '../views/agent/agentChild/publishTenderAnnouncement.vue';
import addTenderAnnouncement from '../views/agent/agentChild/addTenderAnnouncement.vue';
import bidOpeningSummary from '../views/agent/agentChild/bidOpeningSummary.vue';
import printReviewResults from '../views/agent/agentChild/printReviewResults.vue';
import stepRealTimeReview from '../views/agent/agentChild/stepRealTimeReview.vue';
import qualificationReviewList from '../views/agent/agentChild/qualificationReviewList.vue';
import evaluationReport from '../views/agent/agentChild/evaluationReport.vue';
import addEvaluationReport from '../views/agent/agentChild/addEvaluationReport.vue';
import tenderDocumentClarification from '../views/agent/agentChild/tenderDocumentClarification.vue';
import calculateBidScore from '../views/agent/agentChild/calculateBidScore.vue';
import expertQuestionView from '../views/agent/agentChild/expertQuestionView.vue';
import oneClickArchive from '../views/agent/agentChild/oneClickArchive.vue';
import answerBidderQuestions from '../views/agent/agentChild/answerBidderQuestions.vue';
import exportBidAnalysis from '../views/agent/agentChild/exportBidAnalysis.vue';
import bidTermination from '../views/agent/agentChild/bidTermination.vue';
import bidComplaint from '../views/agent/agentChild/bidComplaint.vue';
import openHall from '../views/agent/agentChild/openHall.vue';
import expertExtraction from '../views/agent/agentChild/expertExtraction.vue';
import expertInfoMaintenance from '../views/agent/agentChild/expertInfoMaintenance.vue';
import expertExtractionAudit from '../views/agent/agentChild/expertExtractionAudit.vue';
import singleSourceCreate from '../views/agent/agentChild/singleSourceCreate.vue';
import newSingleSource from '../views/agent/agentChild/newSingleSource.vue';
import expertExtractionList from '../views/agent/agentChild/expertExtractionList.vue';
import expertExtractionFrom from '../views/agent/agentChild/expertExtractionFrom.vue';
import semiProcessChild from '../views/agent/semiProcessChild/index.vue';
import bidEvaluationMethodList from '../views/agent/agentChild/bidEvaluationMethodList.vue';
import winningBidCandidates from '../views/agent/agentChild/winningBidCandidates.vue';
import contract from '../views/agent/agentChild/contract.vue'
import contractAdd from '../views/agent/agentChild/contractAdd.vue'
import pdftest from '../views/pdftest/index.vue'

//评标系统
import expertLogin from '../views/bidEvaluationSystem/expertLogin/index.vue';
import expertEvaluation from '../views/bidEvaluationSystem/expertEvaluation/index.vue';
import bidListMgmt from '../views/bidEvaluationSystem/bidEvaluationSystemChild/bidListMgmt.vue';
import evaluationPage from '../views/bidEvaluationSystem/bidEvaluationSystemChild/evaluationPage.vue';
import qualificateStep from '../views/bidEvaluationSystem/qualificateStep/index.vue';
//投标人
import bidderFlow from '../views/bidder/bidderChild/bidderFlow.vue';
import checkNotice from '../views/bidder/bidderChild/checkNotice.vue';
import makeBidDocument from '../views/bidder/bidderChild/makeBidDocument.vue';
import downloadTender from '../views/bidder/bidderChild/downloadTender.vue';
import bidClarification from '../views/bidder/bidderChild/bidClarification.vue';
import technologyFee from '../views/bidder/bidderChild/technologyFee.vue';
import bidDocument from '../views/bidder/bidderChild/bidDocument.vue';
import confirmBidRecord from '../views/bidder/bidderChild/confirmBidRecord.vue';
import answerJudges from '../views/bidder/bidderChild/answerJudges.vue';
import bidSecondQuotate from '../views/bidder/bidderChild/bidSecondQuotate.vue';
import viewWinBids from '../views/bidder/bidderChild/viewWinBids.vue';
import raiseAQuestion from '../views/bidder/bidderChild/raiseAQuestion.vue';
import bidNoticeSuccessful from '../views/bidder/bidderChild/bidNoticeSuccessful.vue';
import objectionManagement from '../views/bidder/bidderChild/objectionManagement.vue';
import todayEvaluation from '../views/bidEvaluationSystem/bidEvaluationSystemChild/todayEvaluation.vue';
// 签章桥接页
import pdfSignBridge from '../views/sign/pdfSignBridge.vue';
import clarification from '../views/agent/agentChild/clarification.vue';
// 专家库
import expertBankLogin from '../views/expertBank/expertLogin/index.vue';
import expertBankRegister from '../views/expertBank/expertRegister/index.vue';
import expertBankForgetPwd from '../views/expertBank/forgetpwd/index.vue';
import expertBankHome from '../views/expertBank/expertBankHome/index.vue';
// 系统管理员登录（隐藏入口）
import adminAuth from '../views/system/adminAuth/index.vue';
// 先注册VueRouter插件
Vue.use(VueRouter)
//先把VueRouter的push和replace方法保存一份
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function (location, resolve, reject) {
    // 此函数上下文(this指向)为VueRouter的一个实例
    if (resolve && reject) {    //如果我们自己指定了成功/失败的回调，则自己传入
        originPush.call(this, location, resolve, reject)
        //若此时直接使用originPush()方法，则函数内的this指向window（内部代码将无法执行）。故应用call或apply方法修改this指向
    } else {    //如果我们没有指定成功/失败的回调，则自动帮我们生成，防止报错
        originPush.call(this, location, () => { }, () => { })
    }
}
// replace方法同理
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => { }, () => { })
    }
}
//2:映射路由
const routes = [
    {
        path: '/',
        component: Main,
        redirect: '/home',
        children: [
            { path: 'home', name: 'home', component: home },
            { path: 'homeDetail', name: 'homeDetail', component: homeDetail },
            { path: 'deal', name: 'deal', component: deal },
            { path: 'download-center', name: 'downloadCenter', component: downloadCenter },
            { path: 'ca', name: 'ca', component: caHandle },
        ]
    },
    {
      path: '/pdftest',
      component: pdftest,
      name: 'pdftest',
    },
    {
        path: '/register',
        component: register,
        name: 'register',
    },
    {
        path: '/login',
        component: login,
        name: 'login',
    },
    {
        path: '/useLogin',
        component: useLogin,
        name: 'useLogin',
    },
    {
        path: '/ca-file-test',
        component: caFileTest,
        name: 'caFileTest',
    },
    {
        path: '/ca-local-sign-path-test',
        component: caLocalSignPathTest,
        name: 'caLocalSignPathTest',
    },
    {
        path: '/expertLogin',
        component: expertLogin,
        name: 'expertLogin',
    },
    {
        path: '/todayEvaluation',
        component: todayEvaluation,
        name: 'todayEvaluation',
    },
    {
        path: '/qualificateStep',
        component: qualificateStep,
        name: 'qualificateStep',
    },


    {
        path: '/expertEvaluation',
        component: expertEvaluation,
        redirect: '/expertEvaluation/bidListMgmt',
        children: [
            { path: 'bidListMgmt', name: 'bidListMgmt', component: bidListMgmt },//招标列表管理
            { path: 'evaluationPage', name: 'evaluationPage', component: evaluationPage },//评标页面
        ]
    },

    {
        path: '/sys/a7k3z9m4b2f6d0p1t8n5r7y4c3w9g1e6h0j2u8l5v9s4x7q3o1i6a3b9f4z8/auth-entry',
        name: 'adminAuth',
        component: adminAuth
    },
    // 签章桥接页（独立路由，供任意页面跳转使用）
    {
        path: '/sign/pdf',
        name: 'pdfSignBridge',
        component: pdfSignBridge
    },
    // 专家库
    {
        path: '/expertBankLogin',
        component: expertBankLogin,
        name: 'expertBankLogin',
    },
    {
        path: '/expertBankRegister',
        component: expertBankRegister,
        name: 'expertBankRegister',
    },
    {
        path: '/expertBankForgetPwd',
        component: expertBankForgetPwd,
        name: 'expertBankForgetPwd',
    },
    {
        path: '/expertBankHome',
        component: expertBankHome,
        name: 'expertBankHome',
    },
    {
        path: "/bidderHome",
        component: bidderHome,
        redirect: '/bidderHome/todoList',
        children: [
            { path: 'registration', name: 'registration', component: registration },
            { path: 'registrationStatus', name: 'registrationStatus', component: registrationStatus },
            { path: 'uploadBid', name: 'uploadBid', component: uploadBid },
            { path: 'inviteBidding', name: 'inviteBidding', component: inviteBidding },
            { path: 'inviteBiddingPurchase', name: 'inviteBiddingPurchase', component: inviteBiddingPurchase },
            { path: 'myOrders', name: 'myOrders', component: myOrders },
            { path: 'myPurchaseProjects', name: 'myPurchaseProjects', component: myPurchaseProjects },
            { path: 'bidderFlow', name: 'bidderFlowBidder', component: bidderFlow },
            { path: 'checkNotice', name: 'checkNotice', component: checkNotice },
            { path: 'supplementProcurement', name: 'supplementProcurement', component: supplementProcurement },
            { path: 'organizationModify', name: 'organizationModify', component: organizationModify },
            { path: 'professionalPersonnel', name: 'professionalPersonnel', component: professionalPersonnel },
            { path: 'changePassword', name: 'changePassword', component: changePassword },
            { path: 'userInfoModify', name: 'userInfoModify', component: userInfoModify },
            { path: 'creditQuery', name: 'creditQuery', component: creditQuery },
            { path: 'caManagement', name: 'caManagement', component: caManagement },
            { path: 'todoList', name: 'todoList', component: todoList },
            // 二级页面
            { path: 'makeBidDocument', name: 'makeBidDocument', component: makeBidDocument },
            { path: 'downloadTender', name: 'downloadTender', component: downloadTender },
            { path: 'bidClarification', name: 'bidClarification', component: bidClarification },
            { path: 'technologyFee', name: 'technologyFee', component: technologyFee },
            { path: 'bidDocument', name: 'bidDocument', component: bidDocument },
            { path: 'confirmBidRecord', name: 'confirmBidRecord', component: confirmBidRecord },
            { path: 'answerJudges', name: 'answerJudges', component: answerJudges },
            { path: 'bidSecondQuotate', name: 'bidSecondQuotate', component: bidSecondQuotate },
            { path: 'viewWinBids', name: 'viewWinBids', component: viewWinBids },
            { path: 'raiseAQuestion', name: 'raiseAQuestion', component: raiseAQuestion },
            { path: 'bidNoticeSuccessful', name: 'bidNoticeSuccessful', component: bidNoticeSuccessful },
            { path: 'objectionManagement', name: 'objectionManagement', component: objectionManagement },

        ]
    },
    // 大厅页面
    {
        path: "/openHall",
        component: openHall,
        name: 'openHall',
    },
    //编辑评标办法
    {
        path: "/bidEvaluationMethod",
        component: bidEvaluationMethod,
        name: 'bidEvaluationMethod',
    },

    // 代理页面
    {
        path: "/agentHome",
        component: agentHome,
        redirect: '/agentHome/workbench',
        children: [
            { path: 'agentProject', name: 'agentProject', component: agentProject },
            { path: 'workbench', name: 'workbench', component: workbench },
            // 企业采购模块
            { path: 'openTendering', name: 'openTendering', component: openTendering },
            { path: 'competitiveNegotiation', name: 'competitiveNegotiation', component: competitiveNegotiation },
            { path: 'competitiveConsultation', name: 'competitiveConsultation', component: competitiveConsultation },
            { path: 'invitationTendering', name: 'invitationTendering', component: invitationTendering },
            { path: 'inquiryProcurement', name: 'inquiryProcurement', component: inquiryProcurement },
            { path: 'singleSource', name: 'singleSource', component: singleSource },
            { path: 'clarification', name: 'clarification', component: clarification },
            // 政府采购模块
            { path: 'govOpenTendering', name: 'govOpenTendering', component: openTendering },
            { path: 'govCompetitiveNegotiation', name: 'govCompetitiveNegotiation', component: competitiveNegotiation },
            { path: 'govCompetitiveConsultation', name: 'govCompetitiveConsultation', component: competitiveConsultation },
            { path: 'govInvitationTendering', name: 'govInvitationTendering', component: invitationTendering },
            { path: 'govInquiryProcurement', name: 'govInquiryProcurement', component: inquiryProcurement },
            { path: 'govSingleSource', name: 'govSingleSource', component: singleSource },
            // 建设工程模块
            { path: 'constructionOpenTendering', name: 'constructionOpenTendering', component: openTendering },
            // 财务管理模块
            { path: 'financeManagement', name: 'financeManagement', component: financeManagement },
            { path: 'earnestMoneyCheck', name: 'earnestMoneyCheck', component: earnestMoneyCheck },
            { path: 'earnestMoneyRefund', name: 'earnestMoneyRefund', component: earnestMoneyRefund },





            // 综合管理模块
            { path: 'announcementAudit', name: 'announcementAudit', component: announcementAudit },
            { path: 'candidateAudit', name: 'candidateAudit', component: candidateAudit },
            { path: 'resultAudit', name: 'resultAudit', component: resultAudit },
            { path: 'noticeAudit', name: 'noticeAudit', component: noticeAudit },
            { path: 'auditStatusModify', name: 'auditStatusModify', component: auditStatusModify },
            { path: 'bidderRegistrationAudit', name: 'bidderRegistrationAudit', component: bidderRegistrationAudit },
            // 专家管理模块
            { path: 'expertInfoMaintenance', name: 'expertInfoMaintenance', component: expertInfoMaintenance },
            { path: 'expertExtractionAudit', name: 'expertExtractionAudit', component: expertExtractionAudit },
            { path: 'expertExtraction', name: 'expertExtraction', component: expertExtraction },
            { path: 'expertExtractionList', name: 'expertExtractionList', component: expertExtractionList },
            // 系统管理模块
            { path: 'caBinding', name: 'caBinding', component: caBinding },
            { path: 'agentorganizationModify', name: 'agentorganizationModify', component: agentorganizationModify },
            // 半流程模块
            { path: 'semiProcess', name: 'semiProcess', component: semiProcess },
            // 二级页面
            { path: 'addTender', name: 'addTender', component: addTender },//新增
            { path: 'politicsProjectFlow', name: 'politicsProjectFlow', component: politicsProjectFlow },//流出
            { path: 'politicsProjectCreate', name: 'politicsProjectCreate', component: politicsProjectCreate },//创建标段
            { path: 'politicsProjectManage', name: 'politicsProjectManage', component: politicsProjectManage },//标书文件
            { path: 'tenderProMgmt', name: 'tenderProMgmt', component: tenderProMgmt },//招标文件管理
            { path: 'expertExtraction', name: 'expertExtraction', component: expertExtraction },//专家抽取
            { path: 'creatBidFile', name: 'creatBidFile', component: creatBidFile },//创建招标文件
            { path: 'uploadBidFile', name: 'uploadBidFile', component: uploadBidFile },//上传招标文件
            { path: 'detailUploadFile', name: 'detailUploadFile', component: detailUploadFile },//招标文件详情
            { path: 'qualificationReview', name: 'qualificationReview', component: qualificationReview },//设置资格审查内容
            { path: 'winningBidAnnouncement', name: 'winningBidAnnouncement', component: winningBidAnnouncement },//中标公告
            { path: 'bidEvaluationMethodList', name: 'bidEvaluationMethodList', component: bidEvaluationMethodList },//编制评标办法
            { path: 'addBidNotice', name: 'addBidNotice', component: addBidNotice },//新增中标公告
            { path: 'bidOpeningHall', name: 'bidOpeningHall', component: bidOpeningHall },//开标大厅
            { path: 'judgeInfoEntry', name: 'judgeInfoEntry', component: judgeInfoEntry },//录入评委信息
            { path: 'bidResultNotification', name: 'bidResultNotification', component: bidResultNotification },//中标结果通知书
            { path: 'publishTenderAnnouncement', name: 'publishTenderAnnouncement', component: publishTenderAnnouncement },//发布招标公告
            { path: 'addTenderAnnouncement', name: 'addTenderAnnouncement', component: addTenderAnnouncement },//新增招标公告
            { path: 'bidOpeningSummary', name: 'bidOpeningSummary', component: bidOpeningSummary },//开标一览表
            { path: 'printReviewResults', name: 'printReviewResults', component: printReviewResults },//打印评审结果
            { path: 'stepRealTimeReview', name: 'stepRealTimeReview', component: stepRealTimeReview }, //实时查看贫身结果
            { path: 'qualificationReviewList', name: 'qualificationReviewList', component: qualificationReviewList },//资格审查
            { path: 'evaluationReport', name: 'evaluationReport', component: evaluationReport },//评标报告
            { path: 'addEvaluationReport', name: 'addEvaluationReport', component: addEvaluationReport },//添加评标报告
            { path: 'tenderDocumentClarification', name: 'tenderDocumentClarification', component: tenderDocumentClarification },//招标文件澄清与修改
            { path: 'calculateBidScore', name: 'calculateBidScore', component: calculateBidScore },//计算报价分
            { path: 'expertQuestionView', name: 'expertQuestionView', component: expertQuestionView },//查看专家质疑
            { path: 'oneClickArchive', name: 'oneClickArchive', component: oneClickArchive },//一键归档
            { path: 'answerBidderQuestions', name: 'answerBidderQuestions', component: answerBidderQuestions },//解答投标人问题
            { path: 'exportBidAnalysis', name: 'exportBidAnalysis', component: exportBidAnalysis },//导出串标分析结果
            { path: 'bidTermination', name: 'bidTermination', component: bidTermination },//招标异常终止
            { path: 'bidComplaint', name: 'bidComplaint', component: bidComplaint },//招标异常投诉
            { path: 'singleSourceCreate', name: 'singleSourceCreate', component: singleSourceCreate },//创建单一来源
            { path: 'newSingleSource', name: 'newSingleSource', component: newSingleSource },//新建单一来源
            { path: 'expertExtractionFrom', name: 'expertExtractionFrom', component: expertExtractionFrom },//专家抽取
            { path: 'semiProcessChild', name: 'semiProcessChild', component: semiProcessChild },//半流程子页面
            { path: 'winningBidCandidates', name: 'winningBidCandidates', component: winningBidCandidates },//投标人问题
            { path: 'valuationbefore', name: 'valuationbefore', component: valuationbefore },//投标人问题
            { path: 'biddingPlan', name: 'biddingPlan', component: biddingPlan },//招标计划
            { path: 'biddingPlanAdd', name: 'biddingPlanAdd', component: biddingPlanAdd },//招标计划新增
            { path: 'pioneerList', name: 'pioneerList', component: pioneerList },//勘探list
            { path: 'contract', name: 'contract', component: contract },//合同
            { path: 'contractAdd', name: 'contractAdd', component: contractAdd },//合同新增







            // 政府采购子页面路由
            { path: 'govAddTender', name: 'govAddTender', component: addTender },//政府采购新增招标
            { path: 'govPoliticsProjectFlow', name: 'govPoliticsProjectFlow', component: politicsProjectFlow },//政府采购查看流程
            { path: 'govPoliticsProjectCreate', name: 'govPoliticsProjectCreate', component: politicsProjectCreate },//政府采购创建标段
            { path: 'govPoliticsProjectManage', name: 'govPoliticsProjectManage', component: politicsProjectManage },//政府采购招标文件管理
            { path: 'govTenderProMgmt', name: 'govTenderProMgmt', component: tenderProMgmt },//政府采购招标文件管理
            { path: 'govCreatBidFile', name: 'govCreatBidFile', component: creatBidFile },//政府采购创建招标文件
            { path: 'govUploadBidFile', name: 'govUploadBidFile', component: uploadBidFile },//政府采购上传招标文件
            { path: 'govDetailUploadFile', name: 'govDetailUploadFile', component: detailUploadFile },//政府采购招标文件详情
            { path: 'govQualificationReview', name: 'govQualificationReview', component: qualificationReview },//政府采购设置资格审查内容
            { path: 'govWinningBidAnnouncement', name: 'govWinningBidAnnouncement', component: winningBidAnnouncement },//政府采购中标公告
            { path: 'govAddBidNotice', name: 'govAddBidNotice', component: addBidNotice },//政府采购新增中标公告
            { path: 'govBidOpeningHall', name: 'govBidOpeningHall', component: bidOpeningHall },//政府采购开标大厅
            { path: 'govJudgeInfoEntry', name: 'govJudgeInfoEntry', component: judgeInfoEntry },//政府采购录入评委信息
            { path: 'govBidResultNotification', name: 'govBidResultNotification', component: bidResultNotification },//政府采购中标结果通知书
            { path: 'govPublishTenderAnnouncement', name: 'govPublishTenderAnnouncement', component: publishTenderAnnouncement },//政府采购发布招标公告
            { path: 'govAddTenderAnnouncement', name: 'govAddTenderAnnouncement', component: addTenderAnnouncement },//政府采购新增招标公告
            { path: 'govBidOpeningSummary', name: 'govBidOpeningSummary', component: bidOpeningSummary },//政府采购开标一览表
            { path: 'govPrintReviewResults', name: 'govPrintReviewResults', component: printReviewResults },//政府采购打印评审结果
            { path: 'govQualificationReviewList', name: 'govQualificationReviewList', component: qualificationReviewList },//政府采购资格审查
            { path: 'govEvaluationReport', name: 'govEvaluationReport', component: evaluationReport },//政府采购评标报告
            { path: 'govAddEvaluationReport', name: 'govAddEvaluationReport', component: addEvaluationReport },//政府采购添加评标报告
            { path: 'govTenderDocumentClarification', name: 'govTenderDocumentClarification', component: tenderDocumentClarification },//政府采购招标文件澄清与修改
            { path: 'govCalculateBidScore', name: 'govCalculateBidScore', component: calculateBidScore },//政府采购计算报价分
            { path: 'govExpertQuestionView', name: 'govExpertQuestionView', component: expertQuestionView },//政府采购查看专家质疑
            { path: 'govOneClickArchive', name: 'govOneClickArchive', component: oneClickArchive },//政府采购一键归档
            { path: 'govAnswerBidderQuestions', name: 'govAnswerBidderQuestions', component: answerBidderQuestions },//政府采购解答投标人问题
            { path: 'govExportBidAnalysis', name: 'govExportBidAnalysis', component: exportBidAnalysis },//政府采购导出串标分析结果
            { path: 'govBidTermination', name: 'govBidTermination', component: bidTermination },//政府采购招标异常终止
            { path: 'govBidComplaint', name: 'govBidComplaint', component: bidComplaint },//政府采购招标异常投诉

            // 建设工程子页面路由
            { path: 'constructionAddTender', name: 'constructionAddTender', component: addTender },//建设工程新增招标
            { path: 'constructionPoliticsProjectFlow', name: 'constructionPoliticsProjectFlow', component: politicsProjectFlow },//建设工程查看流程
            { path: 'constructionPoliticsProjectCreate', name: 'constructionPoliticsProjectCreate', component: politicsProjectCreate },//建设工程创建标段
            { path: 'constructionPoliticsProjectManage', name: 'constructionPoliticsProjectManage', component: politicsProjectManage },//建设工程招标文件管理
            { path: 'constructionTenderProMgmt', name: 'constructionTenderProMgmt', component: tenderProMgmt },//建设工程招标文件管理
            { path: 'constructionCreatBidFile', name: 'constructionCreatBidFile', component: creatBidFile },//建设工程创建招标文件
            { path: 'constructionUploadBidFile', name: 'constructionUploadBidFile', component: uploadBidFile },//建设工程上传招标文件
            { path: 'constructionDetailUploadFile', name: 'constructionDetailUploadFile', component: detailUploadFile },//建设工程招标文件详情
            { path: 'constructionQualificationReview', name: 'constructionQualificationReview', component: qualificationReview },//建设工程设置资格审查内容
            { path: 'constructionWinningBidAnnouncement', name: 'constructionWinningBidAnnouncement', component: winningBidAnnouncement },//建设工程中标公告
            { path: 'constructionAddBidNotice', name: 'constructionAddBidNotice', component: addBidNotice },//建设工程新增中标公告
            { path: 'constructionBidOpeningHall', name: 'constructionBidOpeningHall', component: bidOpeningHall },//建设工程开标大厅
            { path: 'constructionJudgeInfoEntry', name: 'constructionJudgeInfoEntry', component: judgeInfoEntry },//建设工程录入评委信息
            { path: 'constructionBidResultNotification', name: 'constructionBidResultNotification', component: bidResultNotification },//建设工程中标结果通知书
            { path: 'constructionPublishTenderAnnouncement', name: 'constructionPublishTenderAnnouncement', component: publishTenderAnnouncement },//建设工程发布招标公告
            { path: 'constructionAddTenderAnnouncement', name: 'constructionAddTenderAnnouncement', component: addTenderAnnouncement },//建设工程新增招标公告
            { path: 'constructionBidOpeningSummary', name: 'constructionBidOpeningSummary', component: bidOpeningSummary },//建设工程开标一览表
            { path: 'constructionPrintReviewResults', name: 'constructionPrintReviewResults', component: printReviewResults },//建设工程打印评审结果
            { path: 'constructionQualificationReviewList', name: 'constructionQualificationReviewList', component: qualificationReviewList },//建设工程资格审查
            { path: 'constructionEvaluationReport', name: 'constructionEvaluationReport', component: evaluationReport },//建设工程评标报告
            { path: 'constructionAddEvaluationReport', name: 'constructionAddEvaluationReport', component: addEvaluationReport },//建设工程添加评标报告
            { path: 'constructionTenderDocumentClarification', name: 'constructionTenderDocumentClarification', component: tenderDocumentClarification },//建设工程招标文件澄清与修改
            { path: 'constructionCalculateBidScore', name: 'constructionCalculateBidScore', component: calculateBidScore },//建设工程计算报价分
            { path: 'constructionExpertQuestionView', name: 'constructionExpertQuestionView', component: expertQuestionView },//建设工程查看专家质疑
            { path: 'constructionOneClickArchive', name: 'constructionOneClickArchive', component: oneClickArchive },//建设工程一键归档
            { path: 'constructionAnswerBidderQuestions', name: 'constructionAnswerBidderQuestions', component: answerBidderQuestions },//建设工程解答投标人问题
            { path: 'constructionExportBidAnalysis', name: 'constructionExportBidAnalysis', component: exportBidAnalysis },//建设工程导出串标分析结果
            { path: 'constructionBidTermination', name: 'constructionBidTermination', component: bidTermination },//建设工程招标异常终止
            { path: 'constructionBidComplaint', name: 'constructionBidComplaint', component: bidComplaint },//建设工程招标异常投诉

            // 政府采购竞争性磋商子页面路由
            { path: 'govCompetitiveConsultationAddTender', name: 'govCompetitiveConsultationAddTender', component: addTender },//政府采购竞争性磋商新增招标
            { path: 'govCompetitiveConsultationPoliticsProjectFlow', name: 'govCompetitiveConsultationPoliticsProjectFlow', component: politicsProjectFlow },//政府采购竞争性磋商查看流程
            { path: 'govCompetitiveConsultationPoliticsProjectCreate', name: 'govCompetitiveConsultationPoliticsProjectCreate', component: politicsProjectCreate },//政府采购竞争性磋商创建标段
            { path: 'govCompetitiveConsultationPoliticsProjectManage', name: 'govCompetitiveConsultationPoliticsProjectManage', component: politicsProjectManage },//政府采购竞争性磋商招标文件管理
            { path: 'govCompetitiveConsultationTenderProMgmt', name: 'govCompetitiveConsultationTenderProMgmt', component: tenderProMgmt },//政府采购竞争性磋商招标文件管理
            { path: 'govCompetitiveConsultationCreatBidFile', name: 'govCompetitiveConsultationCreatBidFile', component: creatBidFile },//政府采购竞争性磋商创建招标文件
            { path: 'govCompetitiveConsultationUploadBidFile', name: 'govCompetitiveConsultationUploadBidFile', component: uploadBidFile },//政府采购竞争性磋商上传招标文件
            { path: 'govCompetitiveConsultationDetailUploadFile', name: 'govCompetitiveConsultationDetailUploadFile', component: detailUploadFile },//政府采购竞争性磋商招标文件详情
            { path: 'govCompetitiveConsultationQualificationReview', name: 'govCompetitiveConsultationQualificationReview', component: qualificationReview },//政府采购竞争性磋商设置资格审查内容
            { path: 'govCompetitiveConsultationWinningBidAnnouncement', name: 'govCompetitiveConsultationWinningBidAnnouncement', component: winningBidAnnouncement },//政府采购竞争性磋商中标公告
            { path: 'govCompetitiveConsultationAddBidNotice', name: 'govCompetitiveConsultationAddBidNotice', component: addBidNotice },//政府采购竞争性磋商新增中标公告
            { path: 'govCompetitiveConsultationBidOpeningHall', name: 'govCompetitiveConsultationBidOpeningHall', component: bidOpeningHall },//政府采购竞争性磋商开标大厅
            { path: 'govCompetitiveConsultationJudgeInfoEntry', name: 'govCompetitiveConsultationJudgeInfoEntry', component: judgeInfoEntry },//政府采购竞争性磋商录入评委信息
            { path: 'govCompetitiveConsultationBidResultNotification', name: 'govCompetitiveConsultationBidResultNotification', component: bidResultNotification },//政府采购竞争性磋商中标结果通知书
            { path: 'govCompetitiveConsultationPublishTenderAnnouncement', name: 'govCompetitiveConsultationPublishTenderAnnouncement', component: publishTenderAnnouncement },//政府采购竞争性磋商发布招标公告
            { path: 'govCompetitiveConsultationAddTenderAnnouncement', name: 'govCompetitiveConsultationAddTenderAnnouncement', component: addTenderAnnouncement },//政府采购竞争性磋商新增招标公告
            { path: 'govCompetitiveConsultationBidOpeningSummary', name: 'govCompetitiveConsultationBidOpeningSummary', component: bidOpeningSummary },//政府采购竞争性磋商开标一览表
            { path: 'govCompetitiveConsultationPrintReviewResults', name: 'govCompetitiveConsultationPrintReviewResults', component: printReviewResults },//政府采购竞争性磋商打印评审结果
            { path: 'govCompetitiveConsultationQualificationReviewList', name: 'govCompetitiveConsultationQualificationReviewList', component: qualificationReviewList },//政府采购竞争性磋商资格审查
            { path: 'govCompetitiveConsultationEvaluationReport', name: 'govCompetitiveConsultationEvaluationReport', component: evaluationReport },//政府采购竞争性磋商评标报告
            { path: 'govCompetitiveConsultationAddEvaluationReport', name: 'govCompetitiveConsultationAddEvaluationReport', component: addEvaluationReport },//政府采购竞争性磋商添加评标报告
            { path: 'govCompetitiveConsultationTenderDocumentClarification', name: 'govCompetitiveConsultationTenderDocumentClarification', component: tenderDocumentClarification },//政府采购竞争性磋商招标文件澄清与修改
            { path: 'govCompetitiveConsultationCalculateBidScore', name: 'govCompetitiveConsultationCalculateBidScore', component: calculateBidScore },//政府采购竞争性磋商计算报价分
            { path: 'govCompetitiveConsultationExpertQuestionView', name: 'govCompetitiveConsultationExpertQuestionView', component: expertQuestionView },//政府采购竞争性磋商查看专家质疑
            { path: 'govCompetitiveConsultationOneClickArchive', name: 'govCompetitiveConsultationOneClickArchive', component: oneClickArchive },//政府采购竞争性磋商一键归档
            { path: 'govCompetitiveConsultationAnswerBidderQuestions', name: 'govCompetitiveConsultationAnswerBidderQuestions', component: answerBidderQuestions },//政府采购竞争性磋商解答投标人问题
            { path: 'govCompetitiveConsultationExportBidAnalysis', name: 'govCompetitiveConsultationExportBidAnalysis', component: exportBidAnalysis },//政府采购竞争性磋商导出串标分析结果
            { path: 'govCompetitiveConsultationBidTermination', name: 'govCompetitiveConsultationBidTermination', component: bidTermination },//政府采购竞争性磋商招标异常终止
            { path: 'govCompetitiveConsultationBidComplaint', name: 'govCompetitiveConsultationBidComplaint', component: bidComplaint },//政府采购竞争性磋商招标异常投诉


            // 投标人二级页面路由
            { path: 'bidderFlow', name: 'bidderFlow', component: bidderFlow },//投标人流程

        ]
    },

]

//3:创建实例
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 对外暴露
export default router


